import React from "react";
import { Provider } from "mobx-react";

import MessagingStorage from "../../storages/MessagingStorage";
import Messaging from "./Messaging";

const Container = () => {
  const messagingStorage = new MessagingStorage(
    Application.currentUser.locations
  );
  const storage = { messagingStorage };

  return (
    <Provider {...storage}>
      <Messaging />
    </Provider>
  );
};

export default Container;
